import classNames from 'classnames';
import { BaseSyntheticEvent, useLayoutEffect, useRef, useState } from 'react';
import IconChevronLeftSmall from '@picsart/icons/IconChevronLeftSmall';
import IconChevronRightSmall from '@picsart/icons/IconChevronRightSmall';

import useStyles from './styles';
import { IWithScrollbarArrows } from './types';

function WithScrollbarArrows({ children, className }: IWithScrollbarArrows) {
  const [showLetfArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);
  const classes = useStyles();

  const containerRef = useRef<HTMLDivElement>();

  useLayoutEffect(() => {
    const debouncedHandleResize = () => {
      if (containerRef.current?.clientWidth < containerRef.current?.scrollWidth) {
        setShowRightArrow(true);
      } else {
        setShowRightArrow(false);
      }
    };
    debouncedHandleResize();

    window.addEventListener('resize', debouncedHandleResize);

    return () => window.removeEventListener('resize', debouncedHandleResize);
  }, []);

  const handleOnScroll = (event: BaseSyntheticEvent) => {
    const maxScroll = event.target.scrollWidth - event.target.clientWidth;

    maxScroll == event.target.scrollLeft ? setShowRightArrow(false) : setShowRightArrow(true);
    event.target.scrollLeft == 0 ? setShowLeftArrow(false) : setShowLeftArrow(true);
  };

  return (
    <div className={classNames(classes.root, className)}>
      <IconChevronLeftSmall
        className={classNames(
          classes.leftArrow,
          classes.leftArrowContainer,
          showLetfArrow && classes.block,
        )}
      />
      <div
        ref={containerRef}
        className={classes.container}
        onScroll={(event) => handleOnScroll(event)}
      >
        {children}
      </div>
      <IconChevronRightSmall
        className={classNames(
          classes.rightArrow,
          classes.rightArrowContainer,
          showRightArrow && classes.block,
        )}
      />
    </div>
  );
}

export default WithScrollbarArrows;
